module.exports = __webpack_public_path__ + "img/Polygon.f4e7fdb3.svg";